import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { useEffect } from "react";

const Model = ({ isOpen, onClose, children, name, maxWidth = "max-w-2xl" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center p-4">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-slate-900/60 backdrop-blur-[4px] transition-opacity"
            onClick={onClose}
          />

          {/* Modal Container */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ type: "spring", stiffness: 450, damping: 30 }}
            className={`w-full ${maxWidth} max-h-[95vh] bg-white rounded-[1.5rem] shadow-2xl relative z-10 overflow-hidden flex flex-col`}
          >
            {/* Header Logic */}
            {name ? (
              <div className="px-6 py-4 bg-[#758ecd] flex justify-between items-center border-b border-gray-100 shrink-0">
                <h2 className="text-lg font-bold text-white uppercase tracking-tight">
                  {name}
                </h2>
                <button
                  onClick={onClose}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white hover:bg-white/40 transition-all hover:scale-110 active:scale-95"
                >
                  <IoClose className="text-xl" />
                </button>
              </div>
            ) : (
              <button
                onClick={onClose}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-gray-50 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all z-20 hover:scale-110 active:scale-95"
              >
                <IoClose className="text-xl" />
              </button>
            )}

            {/* Content Area */}
            <div className="overflow-y-auto grow custom-scrollbar">
              <div className="p-1">
                {children}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default Model;
